export function getThirdPartyInfo({ jwt }) {
  return fetch(`${process.env.REACT_APP_API_ENDPOINT}/pd/getThirdPartyInfo`, {
    method: "GET",
    mode: "cors",
    headers: { Authorization: `Bearer ${jwt}` },
  })
    .then((res) => res.json())
    .then((payload) => ({ payload }))
    .catch((error) => ({ error }))
}
